"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadExcelWithDynamicName = exports.downloadExcel = exports.downloadTXT = exports.downloadZIP = exports.downloadPDF = void 0;
/**
 * Generic function to download a file
 * @param content The content
 * @param fileName The name of the file
 * @param mimetype The type of file
 */
function downloadFile(content, fileName, mimetype) {
    let blob;
    if (content instanceof Blob) {
        blob = content;
    }
    else {
        // Create a blob
        blob = new Blob([content], { type: mimetype });
    }
    // TODO: @Javi This is deprecated now, we may removed it
    // Check: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/msSaveOrOpenBlob
    // Use the msSaveOrOpenBlob if available
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        console.log("Using msSaveOrOpenBlob");
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }
    // Create an <a> element and click it
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    // Remove the element created
    setTimeout(function () {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }, 100);
}
exports.default = downloadFile;
/**
 * Download a PDF file
 * @param content The content
 * @param fileName The name of the file
 */
function downloadPDF(content, fileName) {
    return downloadFile(content, fileName, 'application/pdf');
}
exports.downloadPDF = downloadPDF;
/**
 * Download a ZIP file
 * @param content The content
 * @param fileName The name of the file
 */
function downloadZIP(content, fileName) {
    return downloadFile(content, fileName, 'application/zip');
}
exports.downloadZIP = downloadZIP;
/**
 * Download a TXT file
 * @param content The content
 * @param fileName The name of the file
 */
function downloadTXT(content, fileName) {
    return downloadFile(content, fileName, 'text/plain');
}
exports.downloadTXT = downloadTXT;
/**
 * Download a EXCEL file
 * @param content The content
 * @param fileName The name of the file
 */
function downloadExcel(content, fileName) {
    return downloadFile(content, fileName, 'application/vnd.ms-excel');
}
exports.downloadExcel = downloadExcel;
/**
 * Download a EXCEL file
 * @param content The response
 * @param fileNameByDefault The name of the file if we dont receive any name
 */
function downloadExcelWithDynamicName(content, fileNameByDefault) {
    const headerContentDisp = content.headers["content-disposition"];
    const filename = headerContentDisp && headerContentDisp.split("filename=")[1].replace(/["']/g, "") || fileNameByDefault;
    return downloadExcel(content.data, filename);
}
exports.downloadExcelWithDynamicName = downloadExcelWithDynamicName;
